/**
 * Calculates the cumulative scroll position of an element relative to a parent element.
 */

const getCumulativeScrollOffsets = (
  element: HTMLElement,
  parent?: HTMLElement | null
): { left: number; top: number } => {
  let left = 0;
  let top = 0;
  let workingElement: HTMLElement | null = element;

  do {
    left += workingElement.scrollLeft || 0;
    top += workingElement.scrollTop || 0;
    workingElement = workingElement.parentNode as HTMLElement | null;
  } while (workingElement && workingElement !== parent);

  if (workingElement === parent && workingElement) {
    left += workingElement.scrollLeft;
    top += workingElement.scrollTop;
  }

  return { left, top };
};

export { getCumulativeScrollOffsets };
